export const getSafeInternalNextPath = (nextValue, origin = window.location.origin) => {
  if (typeof nextValue !== 'string') {
    return null;
  }
  if (!nextValue.startsWith('/') || nextValue.startsWith('//')) {
    return null;
  }
  const cleanNext = nextValue.trim();
  if (!cleanNext || cleanNext.includes('\n') || cleanNext.includes('\r')) {
    return null;
  }
  try {
    const url = new URL(cleanNext, origin);
    if (url.origin !== origin) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

/**
 * The key for the <router-view> of a route. Vue Router reuses the view when
 * only the route's params change, and a view that reads its params only when
 * it opens (genericDetail, most detail views) then keeps showing the previous
 * object. A route with `meta.remountOnParamsChange` gets its path as key, so
 * the view is built anew for other params; a change to the query alone (a tab,
 * a filter) leaves it as it is. Other routes get no key.
 * @param {object} route the current route
 * @returns {string|undefined}
 */
export const getRouterViewKey = (route) => (
  route?.meta?.remountOnParamsChange ? route.path : undefined
);
